import { mixins, Pie } from 'vue-chartjs';

export default {
  extends: Pie,
  mixins: [mixins.reactiveProp],
  props: ['chartData', 'chartOptions'],
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          position: 'right',
          labels: {
            boxWidth: 20,
            padding: 30,
            fontSize: 14
          }
        }
      }
    };
  },
  mounted() {
    this.renderChart(this.chartData, this.chartOptions);
  }
};
